<template>
	<div class="center_cart_box">
		<center-title>{{$t("message.cart.title")}}</center-title>
		<cart-table></cart-table>
		<!-- 模态框訂單詳情 -->
		<order-status-dialog></order-status-dialog>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapMutations
	} from "vuex";
	export default {
		computed: mapState({
			power: state => state.user.power,
			dialogFalse: state => state.dialogFalse,

		}),
		data() {
			return {
				order_id: 0,
			}
		},
		methods: {
			...mapMutations([
				"handleFalse",
				"handleDialog",
				"handleDialog"

			]),
			...mapActions([
				"getOrderStatusDetail2",


			]),
			getOrderDetails() {
				this.getOrderStatusDetail2(this.order_id, 1).then((res) => {

				})
			}
		},
		components: {
			centerTitle: () => import("@/components/center/centerTitle"),
			cartTable: () => import("@/components/center/cartTable"),
			orderStatusDialog: () => import("@/components/center/orderStatusDialogs"),
		},
		watch: {
			$route: {
				handler: function(route) {
					this.order_id = route.query.id || 0;
					if (this.order_id) {
						this.getOrderDetails();
					}
				}
			},
		},
		mounted() {
			this.order_id = this.$route.query.id || 0;
			if (this.order_id) {
				this.getOrderStatusDetail2(this.order_id, 1).then((res) => {

				})

			}
		},
		beforeDestroy() {
			this.handleDialog(false);
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				setTimeout(() => {
					let allow = vm.power.includes(0) || vm.power.includes(20) || vm.power.includes(111);
					// console.log('查看',allow)
					vm.handleDialog(false);
					if (!allow) {
						vm.$router.back();
						return false;
					} else {


					}
				}, 500)

			})
		},
	}
</script>

<style scoped>

</style>
